export default __webpack_public_path__ + "static/computer_with_graphs-c9e2b85af7eb962f69055fc8f65f4c66.svg";